import { createSlice } from "@reduxjs/toolkit";
import {      reKyc_send_email_otpThunk } from "./thunk";

export const initialState = {
  reKyc_send_email_otpData: [],
  reKyc_send_email_otpError: '', // for error message
  reKyc_send_email_otpLoading: false,
  
  
};

const Re_Kyc_Send_Email_Otp = createSlice({
  name: "Re_Kyc_Send_Email_Otp",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_send_email_otpThunk.pending, (state) => {
      state.reKyc_send_email_otpLoading = true ;
      state.reKyc_send_email_otpData= [];
      state.reKyc_send_email_otpError='';

  });
    builder.addCase(reKyc_send_email_otpThunk.fulfilled, (state, action) => {
        state.reKyc_send_email_otpData = action.payload.data;
        state.reKyc_send_email_otpLoading = false ;
    });
    builder.addCase(reKyc_send_email_otpThunk.rejected, (state, action) => {
      state.reKyc_send_email_otpError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_send_email_otpLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Send_Email_Otp.actions

export default Re_Kyc_Send_Email_Otp.reducer;